<template>
  <div>
    <div class="backupPlan-title">
      <div>{{ $t("RAM.AWS.Backup.Plan.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:backup:serverlessReplications:update'
          ]"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:backup:serverlessReplications:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="backupPlan-top">
      <backup-plan-search ref="search"></backup-plan-search>
    </div>
    <table-backup-plan></table-backup-plan>
  </div>
</template>

<script>
import BackupPlanSearch from "../plan/BackupPlanSearch";
import TableBackupPlan from "../plan/TableBackupPlan";

export default {
  name: "BackupPlan",
  components: {
    BackupPlanSearch,
    TableBackupPlan
  },
  data() {
    return {
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.$api.resourceManagement
        .updateResource({
          resourceManagement: 28,
          accountType: 1
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });

      // 获取子组件数据
      this.companyId = this.$refs.search.companyId;
      this.accountName = this.$refs.search.accountName;
      this.backupPlanName = this.$refs.search.backupPlanName;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAwsBackupPlan({
          companyId: this.companyId,
          accountName: this.accountName,
          backupPlanName: this.backupPlanName
        })
        .then(res => {
          let fileName = "备份计划.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.backupPlan-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.backupPlan-title > div:nth-child(1) {
  float: left;
}
.backupPlan-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.backupPlan-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/backup/plan/BackupPlan.vue